export const BULK_APPROVAL_URL_PATHS = [ '/securities/approve-all', '/securities/reject-all', '/export/approval' ];
